import { Commit } from 'vuex';
import * as Types from './types';
import * as API from './api';
import { IParamsSaveWeeklys, IWeeklyInfo, IWeeklyState } from './interface';
import { Toast } from 'vant';

const state: IWeeklyState = {
    weeklyList: [], //本周数据列表
    historyList: [], //历史数据列表
    createweeklyData: {}, //创建本周数据
    historyweeklyData: {
        IsWeeklySent: 0,
        IsWorkTimeUser: '',
        KnownSchedule: '',
        MonthWorkTime: '',
        MonthlyPoints: '',
        NextFriPlan: '',
        NextFriTarget: '',
        NextMonPlan: '',
        NextMonTarget: '',
        NextSatPlan: '',
        NextSatTarget: '',
        NextSunPlan: '',
        NextSunTarget: '',
        NextThuPlan: '',
        NextThuTarget: '',
        NextTuePlan: '',
        NextTueTarget: '',
        NextWedPlan: '',
        NextWedTarget: '',
        NextWeekPlan: '',
        QuarterlyPoints: '',
        ThisFriDone: '',
        ThisFriItem: '',
        ThisMonDone: '',
        ThisMonItem: '',
        ThisSatDone: '',
        ThisSatItem: '',
        ThisSunDone: '',
        ThisSunItem: '',
        ThisThuDone: '',
        ThisThuItem: '',
        ThisTueDone: '',
        ThisTueItem: '',
        ThisWedDone: '',
        ThisWedItem: '',
        ThisWeekDone: '',
        WeeklyTemplateId: 1,
        WeeklyTitle: '1',
        WeeklyWorkTime: '',
        WorkThought: '',
    }, //历史数据
    weeklyInfo: {} as IWeeklyInfo,
    saveweeklyBol: Boolean,
    resetweeklyData: {},
    SaveWeeklyResult: {},
    loadingWeeklyData: false,
    thisMonDay: '',
    nextMonDay: '',
    lastMonDay: '',
    saveWeeklys: {} as IParamsSaveWeeklys,
    reportLoading: false,
    reportData: {},
    image: {},
};
const actions = {
    [Types.WEEKLY_INFO](context: { commit: Commit; state: IWeeklyState }) {
        const weeklyInfo: IWeeklyInfo = JSON.parse(localStorage.getItem('loginUser') as string);
        context.commit(Types.WEEKLY_INFO, weeklyInfo);
    },
    //获取本周周报
    async [Types.GET_WEEKLY_LIST](context: { commit: Commit; state: IWeeklyState }, params: any) {
        let weeklyList: any = [];
        context.commit(Types.GET_WEEKLY_LIST, { loading: true, weeklyList });
        weeklyList = await API.GetWeeklyList(params);
        context.commit(Types.GET_WEEKLY_LIST, { loading: false, weeklyList });
    },
    // 获取历史周报
    async [Types.GET_WEEKLY_HISTORY_LIST](context: { commit: Commit; state: IWeeklyState }, params: any) {
        let historyList: any = [];
        context.commit(Types.GET_WEEKLY_HISTORY_LIST, { loading: true, historyList });
        historyList = await API.GetWeeklyList(params);
        context.commit(Types.GET_WEEKLY_HISTORY_LIST, { loading: false, historyList });
    },
    // 获取用户历史周报信息
    async [Types.GET_HISTORY_WEEKLY](context: { commit: Commit; state: IWeeklyState }, params: any) {
        let weeklyInfo: any = {};
        context.commit(Types.GET_HISTORY_WEEKLY, { loading: true, weeklyInfo });
        weeklyInfo = await API.GetHistoryWeekly(params);
        context.commit(Types.GET_HISTORY_WEEKLY, { loading: false, weeklyInfo });
    },
    // 获取用户周报信息
    async [Types.GET_WEEKLY](context: { commit: Commit; state: IWeeklyState }, params: any) {
        let weeklyInfo: any = {};
        context.commit(Types.GET_WEEKLY, { loading: true, weeklyInfo });
        weeklyInfo = await API.GetWeekly(params);
        context.commit(Types.GET_WEEKLY, { loading: false, weeklyInfo });
    },
    //保存周报
    async [Types.SAVE_WEEKLY](context: { commit: Commit; state: IWeeklyState }, params: IParamsSaveWeeklys) {
        if (params.SaveType == 'AutoSave') {
            let result: any = {};
            result = await API.SaveWeekly(params);
            await context.commit(Types.SAVE_WEEKLY, result);
        } else {
            let result: any = {};
            Toast.loading({
                duration: 0,
                forbidClick: true,
                message: '保存中...',
            });
            result = await API.SaveWeekly(params);
            await context.commit(Types.SAVE_WEEKLY, result);

            if (result.WeeklyTitle) {
                Toast.success('保存成功');
            }
        }
    },
    //同步
    async [Types.RESET_WEEKLY](context: { commit: Commit; state: IWeeklyState }, params: any) {
        Toast.loading({
            duration: 0,
            forbidClick: true,
            message: '同步中...',
        });
        const result = await API.ResetWeekly(params);
        context.commit(Types.RESET_WEEKLY, result);
    },
    //反填
    async [Types.FILL_NEXT_WORK](context: { commit: Commit; state: IWeeklyState }, params: any) {
        Toast.loading({
            duration: 0,
            forbidClick: true,
            message: '反填中...',
        });
        const result = await API.BackfillNextWeekWorkPlan(params);
        context.commit(Types.FILL_NEXT_WORK, result);
    },
    //发送
    async [Types.SENT_WEEKLY](context: { commit: Commit; state: IWeeklyState }, params: { operType: number; data: IParamsSaveWeeklys }) {
        let result = {};
        Toast.loading({
            duration: 0,
            forbidClick: true,
            message: '保存并发送中...',
        });
        await context.commit(Types.SENT_WEEKLY, { loading: true, result });
        result = await API.SendWeekly(params);
        if (result) {
            Toast.success('发送成功');
        }
    },
    async [Types.GET_WEEKLY_STATISTICS_DATA](context: { commit: Commit; state: IWeeklyState }, params: any) {
        let result = {};
        context.commit(Types.GET_WEEKLY_STATISTICS_DATA, { loading: true, result });
        result = await API.GetWeeklyStatisticsData(params);
        context.commit(Types.GET_WEEKLY_STATISTICS_DATA, { loading: false, result });
    },
    async [Types.UPLOAD_IMAGES](context: { commit: Commit; state: any }, params: any) {
        const image: any = await API.uploadImages(params);
        context.commit(Types.UPLOAD_IMAGES, image);
    },
};

const mutations = {
    [Types.WEEKLY_INFO](state: IWeeklyState, weeklyInfo: IWeeklyInfo) {
        state.weeklyInfo = weeklyInfo;
    },
    [Types.GET_WEEKLY_LIST](state: IWeeklyState, payload: any) {
        state.loadingWeeklyData = payload.loading;
        state.weeklyList = payload.weeklyList;
    },
    [Types.GET_WEEKLY_HISTORY_LIST](state: IWeeklyState, payload: any) {
        state.loadingWeeklyData = payload.loading;
        state.historyList = payload.historyList;
    },
    [Types.GET_HISTORY_WEEKLY](state: IWeeklyState, payload: any) {
        state.loadingWeeklyData = payload.loading;
        state.historyweeklyData = payload.weeklyInfo.weeklyData;
        state.thisMonDay = payload.weeklyInfo.thisMonDay;
        state.lastMonDay = payload.weeklyInfo.lastMonDay;
        state.nextMonDay = payload.weeklyInfo.nextMonDay;
    },

    [Types.GET_WEEKLY](state: IWeeklyState, payload: any) {
        state.loadingWeeklyData = payload.loading;
        state.createweeklyData = payload.weeklyInfo;
    },
    [Types.SAVE_WEEKLY](state: IWeeklyState, payload: any) {
        state.SaveWeeklyResult = payload.result;
    },
    [Types.RESET_WEEKLY](state: IWeeklyState, payload: any) {
        if (payload !== '') {
            Toast.success('同步成功');
        } else {
            Toast.fail('同步失败');
        }
        state.resetweeklyData = payload;
    },
    [Types.FILL_NEXT_WORK](state: IWeeklyState, payload: any) {
        if (payload == true) {
            Toast.success('反填成功');
        } else {
            Toast.fail('反填失败');
        }
    },
    [Types.SENT_WEEKLY](state: IWeeklyState, payload: any) {
        state.SaveWeeklyResult = payload.result;
    },
    [Types.GET_WEEKLY_STATISTICS_DATA](state: IWeeklyState, payload: any) {
        state.reportLoading = payload.loading;
        state.reportData = payload.result;
    },
    [Types.UPLOAD_IMAGES](state: IWeeklyState, image: any) {
        state.image = image;
    },
};

export default { namespaced: true, state, actions, mutations };
